import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { MessageCircleMore, X } from 'lucide-react';
import ChatWindow from './chat/ChatWindow';
import { API, trackClick } from './landing/constants';

export const ChatAssistant = ({ article }) => {
  const [config, setConfig] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    axios.get(`${API}/chat/config`).then(({ data }) => setConfig(data)).catch(() => setConfig({ enabled: false }));
  }, []);

  if (!config?.enabled) return null;

  const toggle = () => {
    if (!open) trackClick('Chat IA');
    setOpen((o) => !o);
  };

  return (
    <>
      {open && <ChatWindow config={config} article={article} onClose={() => setOpen(false)} />}
      <button
        type="button"
        onClick={toggle}
        data-testid="chat-toggle-btn"
        aria-label={open ? 'Cerrar asistente' : 'Abrir asistente virtual'}
        className="fixed bottom-6 left-6 sm:left-auto sm:right-[11.5rem] z-50 flex items-center gap-2 rounded-full bg-slate-950 text-white pl-4 pr-5 py-3 shadow-2xl shadow-blue-900/40 hover:scale-105 hover:bg-slate-900 transition-[transform,background-color] duration-300"
      >
        {open ? <X className="h-6 w-6" /> : <MessageCircleMore className="h-6 w-6 text-blue-400" />}
        <span className="font-semibold text-sm">{open ? 'Cerrar' : 'Asistente IA'}</span>
      </button>
    </>
  );
};

export default ChatAssistant;
